import type { UploadFile } from 'antd';
import type { KmsDocumentTypeOption } from './types';

export const KMS_DOCUMENT_TYPE_OPTIONS: KmsDocumentTypeOption[] = [
  { value: 'technical_manual', labelKey: 'documentTypes.technicalManual' },
  { value: 'maintenance_reports', labelKey: 'documentTypes.maintenanceReport' },
  {
    value: 'maintenance_contracts',
    labelKey: 'documentTypes.maintenanceContract',
  },
  { value: 'asset_info_sheets', labelKey: 'documentTypes.assetInfoSheet' },
  { value: 'compliance_doc', labelKey: 'documentTypes.complianceDoc' },
  { value: 'media', labelKey: 'documentTypes.media' },
  { value: 'structured_data', labelKey: 'documentTypes.structuredData' },
  { value: 'other', labelKey: 'documentTypes.other' },
];

export function kmsUploadFileUid(file: File): string {
  return `${file.name}-${file.size}-${file.lastModified}`;
}

export function isSameKmsUploadFile(a: File, b: File): boolean {
  return (
    a.name === b.name && a.size === b.size && a.lastModified === b.lastModified
  );
}

/** Sync selected File[] from antd controlled Upload fileList. */
export function syncKmsSelectedFilesFromUploadList(
  fileList: UploadFile[],
  current: File[],
): File[] {
  return fileList
    .map((item) => {
      if (item.originFileObj instanceof File) {
        return item.originFileObj;
      }
      return current.find((entry) => kmsUploadFileUid(entry) === item.uid);
    })
    .filter((file): file is File => file instanceof File);
}
